
import React from 'react'
import Image from '~/components/atoms/Image'
import FadeInWhenVisible from '~/components/FadeInWhenVisible'

export default function Value({className, ...item}) {
  return (
    <div className={` ${className}`}>
      <FadeInWhenVisible>
        <Image data={item.illustration} className="h-48 w-48 mb-4 mx-auto md:ml-0" objectFit="contain" objectPosition="center" />
      </FadeInWhenVisible>
      <FadeInWhenVisible>
        <h5 className="text-h5 mb-3">{item.heading}</h5>
      </FadeInWhenVisible>
      <FadeInWhenVisible>
        <p>{item.content}</p>
      </FadeInWhenVisible>
    </div>
  )
}
